import { motion } from "framer-motion";
import { Truck, BadgeCheck, Package, Tag } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const PERKS = [
  {
    icon: Tag,
    title: "Prezzi di Ingrosso",
    text: "Listini chiari e competitivi su marchi selezionati: Wrangler, Freddy e Nautica.",
  },
  {
    icon: Truck,
    title: "Spedizione Rapida",
    text: "Spedizione rapida in Europa e nel mondo, con tracciamento completo di ogni lotto.",
  },
  {
    icon: Package,
    title: "Box per Colore",
    text: "Cartoni da 10 o 12 paia per singolo colore: assortimenti taglie pronti alla vendita.",
  },
];

export default function Trust() {
  return (
    <section className="border-t border-black/10 bg-white" data-testid="trust-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta"
        >
          Perché i grossisti scelgono iogama
        </motion.p>
        <div className="mt-12 grid grid-cols-1 gap-px bg-black/10 sm:grid-cols-3 lg:grid-cols-3">
          {PERKS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="group bg-white p-8 transition-colors duration-500 hover:bg-ink"
              data-testid={`perk-${i}`}
            >
              <p.icon className="h-7 w-7 text-terracotta" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-ink transition-colors duration-500 group-hover:text-white">
                {p.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/55 transition-colors duration-500 group-hover:text-white/60">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
